.page {
  min-height: calc(100vh - var(--navbar-height));
  background: var(--bg-primary);
  padding: var(--space-3xl) var(--space-lg);
}

.container {
  max-width: 820px;
  margin: 0 auto;
}

.header {
  margin-bottom: var(--space-2xl);
}

.kicker {
  font-family: var(--font-heading);
  font-size: var(--text-xs);
  letter-spacing: 4px;
  color: var(--accent-cyan);
  border: 1px solid var(--border-accent);
  border-radius: var(--radius-sm);
  padding: var(--space-xs) var(--space-sm);
  display: inline-block;
  margin-bottom: var(--space-md);
}

.title {
  font-family: var(--font-heading);
  font-size: var(--text-3xl);
  letter-spacing: 2px;
  color: var(--text-primary);
  margin-bottom: var(--space-md);
}

.subtitle {
  font-size: var(--text-base);
  color: var(--text-secondary);
  line-height: 1.7;
}

.block {
  margin-bottom: var(--space-2xl);
  padding: var(--space-lg);
  background: var(--bg-surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
}

/* ── 工具集切换 Tabs ── */
.tabsRow {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-md);
  flex-wrap: wrap;
  margin-bottom: var(--space-2xl);
}

.targetTabs {
  display: flex;
  gap: var(--space-sm);
}

.targetTab {
  font-family: var(--font-heading);
  font-size: var(--text-base);
  letter-spacing: 1px;
  color: var(--text-secondary);
  background: var(--bg-surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: var(--space-sm) var(--space-lg);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: var(--space-sm);
  transition: color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}

.targetTab:hover {
  color: var(--accent-cyan);
  border-color: var(--border-accent);
}

.targetTabActive {
  color: var(--accent-cyan);
  border-color: var(--accent-cyan);
  box-shadow: 0 0 8px rgba(0, 240, 255, 0.25);
}

.targetTabHint {
  font-family: var(--font-code);
  font-size: var(--text-xs);
  letter-spacing: 0;
  color: var(--text-muted);
  border: 1px dashed var(--border);
  border-radius: var(--radius-sm);
  padding: 1px 6px;
}

.targetTabActive .targetTabHint {
  color: var(--accent-cyan);
  border-color: var(--border-accent);
}

/* ── 一键复制（复制给 AI） ── */
.copyBtn {
  font-family: var(--font-code);
  font-size: var(--text-sm);
  letter-spacing: 1px;
  color: var(--accent-green);
  background: transparent;
  border: 1px solid var(--accent-green);
  border-radius: var(--radius-sm);
  padding: var(--space-sm) var(--space-lg);
  cursor: pointer;
  transition: color 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
  white-space: nowrap;
}

.copyBtn:hover {
  box-shadow: 0 0 8px rgba(57, 255, 20, 0.3);
}

.copyBtnDone {
  color: var(--accent-cyan);
  border-color: var(--accent-cyan);
  box-shadow: 0 0 8px rgba(0, 240, 255, 0.25);
  opacity: 1;
}

.copyBtnFailed {
  color: var(--accent-magenta, #ff2d95);
  border-color: var(--accent-magenta, #ff2d95);
  box-shadow: 0 0 8px rgba(255, 45, 149, 0.3);
}

.blockTitle {
  font-family: var(--font-heading);
  font-size: var(--text-lg);
  letter-spacing: 1px;
  color: var(--accent-cyan);
  margin-bottom: var(--space-md);
}

.blockText {
  font-size: var(--text-sm);
  color: var(--text-secondary);
  line-height: 1.8;
  margin-bottom: var(--space-md);
}

.blockText code,
.notes code {
  font-family: var(--font-code);
  font-size: 0.82em;
  color: var(--accent-cyan);
  background: rgba(0, 240, 255, 0.08);
  border: 1px solid var(--border-accent);
  border-radius: var(--radius-sm);
  padding: 1px 6px;
}

.code {
  font-family: var(--font-code);
  font-size: var(--text-sm);
  color: var(--accent-green);
  background: var(--bg-elevated);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: var(--space-md);
  overflow-x: auto;
  line-height: 1.6;
  white-space: pre;
}

.toolTable {
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);
}

.toolRow {
  display: flex;
  align-items: baseline;
  gap: var(--space-md);
  padding: var(--space-sm) var(--space-md);
  background: var(--bg-elevated);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
}

.toolName {
  font-family: var(--font-code);
  font-size: var(--text-sm);
  color: var(--accent-cyan);
  min-width: 190px;
}

.toolDesc {
  font-size: var(--text-sm);
  color: var(--text-secondary);
}

.notes {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);
}

.notes li {
  position: relative;
  padding-left: var(--space-lg);
  font-size: var(--text-sm);
  color: var(--text-secondary);
  line-height: 1.7;
}

.notes li::before {
  content: '▸';
  position: absolute;
  left: 0;
  color: var(--accent-cyan);
}

@media (max-width: 640px) {
  .toolRow {
    flex-direction: column;
    gap: var(--space-xs);
  }
  .toolName {
    min-width: 0;
  }
}
